import { render, staticRenderFns } from "./CreateNewsModal.vue?vue&type=template&id=1e64f368&scoped=true&"
import script from "./CreateNewsModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e64f368",
  null
  
)

export default component.exports